import { Section } from '@factorialco/deprecated-design-system'
import { PerformanceProcessSettingsDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'
import i18n from 'modules/core/lib/i18n'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import { CompanyEmployeeScoreScaleSelector } from 'modules/performance_process/components/companyEmployeeScoreScaleSelector'
import SettingsCollectionsBootstrap from 'modules/performance_process/lib/SettingsCollectionsBootstrap'

const Component = () => {
  const { company } = useCurrentSession()
  const { data, loading, error } = useQuery(PerformanceProcessSettingsDocument, {
    variables: { companyId: company.id },
  })

  const canSeeSettings =
    !!data?.performance._policies.settingsSeePerformanceReviewProcessSettings.can
  const scaleId = data?.performance.companyEmployeeScoreScales[0]?.scaleId
  const scoreScales = data?.performance.employeeScoreScalesConnection.nodes || []

  return (
    <ResponsivePage.Body
      authorized={canSeeSettings}
      loading={loading}
      error={error}
      showHeader={false}
    >
      <Section.Form
        illustration="eNPS"
        title={i18n.t('performance_process.employee_score.company_settings.title')}
        description={i18n.t('performance_process.employee_score.company_settings.description')}
      >
        <CompanyEmployeeScoreScaleSelector
          companyId={company.id}
          currentScaleId={scaleId}
          scoreScales={scoreScales}
        />
      </Section.Form>
    </ResponsivePage.Body>
  )
}

const PerformanceProcessSettings = () => {
  return (
    <SettingsCollectionsBootstrap>
      <Component />
    </SettingsCollectionsBootstrap>
  )
}

export default PerformanceProcessSettings
